/* eslint-disable no-unused-vars */
export enum ExportOptions {
    PDF = 'PDF',
    EXCEL = 'Excel',
}
